// eslint-disable-next-line no-restricted-imports
import store from '@/vuex/store';

/*
 * At one point or another, these routes were all live - now, we just need to preserve them
 * so that existing bookmarks, emails, etc, still remain functional as links
 */

// console.error(
//     "TODO: old redirect for ideatests still needs to get updated for migration - don't merge without fixing!"
// );

// Routes that should ultimately redirect to /s/:subid/the/route
// If you have a global route (aka no sub id), see the next array
export const redirectLegacyRoutesWithSubId = [
    // all /kind/tmp routes were deprecated in May 2025 in favor of /kind-report
    // people may have bookmarked these, so keep them around for some amount of
    // time, but at some point you can probably check the analytics on the
    // routes and just delete them
    { path: 'visitorlist/tmp', redirect: adhocListRedirect },
    { path: 'accountlist/tmp', redirect: adhocListRedirect },
    { path: 'parentaccountlist/tmp', redirect: adhocListRedirect },
    { path: 'admin/blacklist', redirect: '/admin/exclude-list' },
    { path: 'admin/integrationkeys', redirect: '/admin/integrations' },
    { path: 'admin/partner-settings', redirect: '/adoptv2/admin/partner-settings' },
    { path: 'admin/rawevents', redirect: '/admin' },
    { path: 'data-explorer/reports', redirect: '/reports' },
    { path: 'discover', redirect: '/listen' },
    { path: 'discover/automationrules', redirect: '/listen/automationrules' },
    { path: 'discover/feedback', redirect: '/listen/feedback' },
    {
        path: 'discover/feedback/:itemId',
        redirect: (to) => ({
            name: 'ListenFeedbackAllFeedbackView',
            query: { ...to.query, openItem: to.params.itemId },
        }),
    },
    { path: 'discover/feedback/form', redirect: '/listen/feedback/form' },
    { path: 'discover/feedback/views', redirect: '/listen/feedback/views' },
    {
        path: 'discover/feedback/views/:savedviewId',
        redirect: generateNamedRouteRedirect('ValidateFeedbackSavedViewTabs'),
    },
    {
        path: 'discover/feedback/views/:savedviewId/:tab',
        redirect: generateNamedRouteRedirect('ValidateFeedbackSavedViewTabs'),
    },
    { path: 'discover/portals', redirect: '/listen/portals' },
    { path: 'discover/portals/settings/:portalId', redirect: generateNamedRouteRedirect('VocPortalSettingsTab') },
    { path: 'discover/validate', redirect: '/listen/validate' },
    { path: 'discover/validate/analysis', redirect: '/listen/validate/analysis' },
    { path: 'discover/validate/ideatests', redirect: '/listen/validate/ideatests' },
    // { path: 'discover/validate/ideatests/:guideId', redirect: generateNamedRouteRedirect('/listen/validate/ideatests/:guideId') },
    { path: 'discover/validate/roi', redirect: '/listen/validate/roi' },
    { path: 'executive-summary', redirect: '/portfolio-summary' },
    { path: 'groups', redirect: '/product-areas-list' },
    { path: 'groups-list', redirect: '/product-areas-list' },
    { path: 'groups-list', redirect: '/product-areas-list' },
    { path: 'groups/:id', redirect: generateNamedRouteRedirect('ProductAreaDetails') },
    { path: 'pages/untagged-urls', redirect: '/pages/untagged' },
    { path: 'validate', redirect: '/listen/validate' },
    { path: 'validate/analysis', redirect: '/listen/validate/analysis' },
    { path: 'validate/feedback/savedviews', redirect: '/listen/feedback/views' },
    {
        path: 'validate/feedback/savedviews/:savedviewId',
        redirect: generateNamedRouteRedirect('ValidateFeedbackSavedViewTabs'),
    },
    {
        path: 'validate/feedback/savedviews/:savedviewId/:tab',
        redirect: generateNamedRouteRedirect('ValidateFeedbackSavedViewTabs'),
    },
    {
        path: 'net-promoter-system/guides/:guideId/polls/:pollId',
        redirect: (to) => {
            let { subId, ...otherQueryParams } = to.query;
            if (!subId) {
                subId = store.state.subscription?.active?.id;
            }

            return {
                ...to,
                name: 'NPSGuideDetails',
                params: {
                    ...to.params,
                    sub: subId,
                },
                query: otherQueryParams,
            };
        },
    },
    /** Redirects for Listen Salesforce integration (remove in APP-102198) */
    { path: 'validate/feedbackform/external', redirect: '/listen/feedback/form' },
    { path: 'validate/ideaTests', redirect: '/listen/validate/ideatests' },
    { path: 'validate/roi', redirect: '/listen/validate/roi' },
    { path: 'workflow-report/:id?', redirect: generateNamedRouteRedirect('Workflow') },
    { path: 'workflow-report/:id?/:tab?', redirect: generateNamedRouteRedirect('Workflow') },
];

// Routes that should redirect _without_ subid in the url
export const redirectLegacyRoutesGlobal = [{ path: '/settings', redirect: '/user-profile' }];

// vue-router doesn't automatically map params in redirects, so something like:
// { path: '/groups/:id', redirect: '/product-areas/:id' }
// will result in you being redirected to the literal `/product-areas/:id`, rather than
// swapping in the id param. Instead, we'll mirror params over to a new route object,
// with a reference to the new named route
// NOTE: This is _not_ the same as using `alias` - alias will preserve the original route string,
// so for instance if you go to /groups/:id, using alias will preserve the url as /groups/asdf.
// redirect will instead rewrite the url as /product-area/asdf - this may or may not matter
// depending on what your PM wants to do with the old routes
function generateNamedRouteRedirect (currentRouteName) {
    return (to) => {
        return {
            ...to,
            name: currentRouteName,
        };
    };
}

function adhocListRedirect (to) {
    const reportHash = window.location.hash.replace('#', '');

    if (!reportHash) {
        return { name: 'NotFound' };
    }

    return {
        name: 'AdhocKindReport',
        params: {
            encodedReport: reportHash,
        },
        query: to.query,
    };
}
